<template>
  <div class="resume-section profile-section" :class="{ 'is-compact': compact }">
    <h1 class="profile-name" :style="{ color: themeColor }">
      {{ section.data.fullName || 'Your Name' }}
    </h1>
    <p class="profile-title">{{ section.data.title || 'Your Title' }}</p>
    <div class="profile-contacts">
      <span v-if="section.data.email" class="profile-contact">
        <icon name="email" class="w-3.5 h-3.5 opacity-60" />
        {{ section.data.email }}
      </span>
      <span v-if="section.data.phone" class="profile-contact">
        <icon name="phone" class="w-3.5 h-3.5 opacity-60" />
        {{ section.data.phone }}
      </span>
      <span v-if="section.data.location" class="profile-contact">
        <icon name="location" class="w-3.5 h-3.5 opacity-60" />
        {{ section.data.location }}
      </span>
    </div>
    <p v-if="section.data.summary" class="profile-summary">{{ section.data.summary }}</p>
  </div>
</template>

<script>
import Icon from '@/Shared/Icon.vue'

export default {
  components: { Icon },
  props: {
    section: {
      type: Object,
      required: true
    },
    themeColor: {
      type: String,
      default: '#0f766e'
    },
    compact: {
      type: Boolean,
      default: false
    }
  }
}
</script>

<style scoped>
.profile-name {
  font-family: var(--ps-font-resume-display), Georgia, serif;
  font-size: clamp(1.75rem, 3vw, 2.35rem);
  font-weight: 700;
  letter-spacing: -0.03em;
  line-height: 1.15;
  margin-bottom: 0.35rem;
}

.profile-title {
  font-size: 1rem;
  font-weight: 600;
  color: #475569;
  margin-bottom: 0.85rem;
}

.profile-contacts {
  display: flex;
  flex-wrap: wrap;
  gap: 0.65rem 1rem;
  font-size: 0.85rem;
  color: #64748b;
}

.profile-contact {
  display: inline-flex;
  align-items: center;
  gap: 0.35rem;
}

.profile-summary {
  margin-top: 1rem;
  color: #334155;
  line-height: 1.65;
  font-size: 0.95rem;
}

.is-compact .profile-name {
  font-size: 1.45rem;
}

.is-compact .profile-contacts {
  flex-direction: column;
  gap: 0.4rem;
}
</style>
